import React from 'react';
import { FormattedMessage } from 'react-intl';


const CardComparisonInsurancePerksSection = {
    sectionId: 'insurance-perks',
    sectionLabel: (
        <FormattedMessage
            id="edb.cc.side-by-side-v2.insurance-perks"
            defaultMessage="Insurance & perks"
        />
    ),
    items: [
        {
            cardPropertyKey: 'loungeAccess',
            isExpandable: false,
            displayValue: (
                <FormattedMessage
                    id="edb.cc.side-by-side-v2.lounge-access"
                    defaultMessage="Lounge access"
                />
            ),
        },
        {
            cardPropertyKey: 'foreignTransactionFees',
            isExpandable: false,
            displayValue: (
                <FormattedMessage
                    id="edb.cc.side-by-side-v2.foreign-transaction-fees"
                    defaultMessage="Waived foreign transaction fees"
                />
            ),
        },
        {
            cardPropertyKey: 'travelAccidentInsurance',
            isExpandable: false,
            displayValue: (
                <FormattedMessage
                    id="edb.cc.side-by-side-v2.travel-accident-insurance"
                    defaultMessage="Travel accident insurance"
                />
            ),
        },
        {
            cardPropertyKey: 'travelEmergencyMedical',
            isExpandable: false,
            displayValue: (
                <FormattedMessage
                    id="edb.cc.side-by-side-v2.travel-emergency-medical"
                    defaultMessage="Travel emergency medical"
                />
            ),
        },
        {
            cardPropertyKey: 'carRentalInsurance',
            isExpandable: false,
            displayValue: (
                <FormattedMessage
                    id="edb.cc.side-by-side-v2.car-rental-insurance"
                    defaultMessage="Car rental insurance"
                />
            ),
        },
        {
            cardPropertyKey: 'tripCancellation',
            isExpandable: false,
            displayValue: (
                <FormattedMessage
                    id="edb.cc.side-by-side-v2.trip-cancellation"
                    defaultMessage="Trip cancellation"
                />
            ),
        },
        {
            cardPropertyKey: 'tripInterruption',
            isExpandable: false,
            displayValue: (
                <FormattedMessage
                    id="edb.cc.side-by-side-v2.trip-interruption"
                    defaultMessage="Trip interruption"
                />
            ),
        },
        {
            cardPropertyKey: 'flightDelayInsurance',
            isExpandable: false,
            displayValue: (
                <FormattedMessage
                    id="edb.cc.side-by-side-v2.flight-delay-insurance"
                    defaultMessage="Flight delay insurance"
                />
            ),
        },
        {
            cardPropertyKey: 'baggageLossInsurance',
            isExpandable: false,
            displayValue: (
                <FormattedMessage
                    id="edb.cc.side-by-side-v2.baggage-loss-insurance"
                    defaultMessage="Baggage loss insurance"
                />
            ),
        },
        {
            cardPropertyKey: 'baggageDelayInsurance',
            isExpandable: false,
            displayValue: (
                <FormattedMessage
                    id="edb.cc.side-by-side-v2.baggage-delay-insurance"
                    defaultMessage="Baggage delay insurance"
                />
            ),
        },
        {
            cardPropertyKey: 'hotelBurglary',
            isExpandable: false,
            displayValue: (
                <FormattedMessage
                    id="edb.cc.side-by-side-v2.hotel-burglary"
                    defaultMessage="Hotel/motel burglary"
                />
            ),
        },
        {
            cardPropertyKey: 'mobileInsurance',
            isExpandable: false,
            displayValue: (
                <FormattedMessage
                    id="edb.cc.side-by-side-v2.mobile-insurance"
                    defaultMessage="Mobile insurance"
                />
            ),
        },
        {
            cardPropertyKey: 'purchaseAssurance',
            isExpandable: false,
            displayValue: (
                <FormattedMessage
                    id="edb.cc.side-by-side-v2.purchase-assurance"
                    defaultMessage="Purchase assurance"
                />
            ),
        },
        {
            cardPropertyKey: 'extendedWarranty',
            isExpandable: false,
            displayValue: (
                <FormattedMessage
                    id="edb.cc.side-by-side-v2.extended-warranty"
                    defaultMessage="Extended warranty"
                />
            ),
        },
        {
            cardPropertyKey: 'priceProtection',
            isExpandable: false,
            displayValue: (
                <FormattedMessage
                    id="edb.cc.side-by-side-v2.price-protection"
                    defaultMessage="Price protection"
                />
            ),
        },
    ],
};

export default CardComparisonInsurancePerksSection;
